class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    
    // Only add mouse event listeners if not a touch device
    if (!('ontouchstart' in window || navigator.maxTouchPoints > 0)) {
      this.mainDetailsToggle.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.mainDetailsToggle.addEventListener('mouseleave', this.onMouseLeave.bind(this));
    }
    
    // Track animation state
    this.isAnimating = false;
    this.closeTimeout = null;

    // Initialize with hidden state
    if (this.content) {
      this.content.classList.add('dropdown-hidden');
    }
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onMouseEnter() {
    // Clear any pending close animation
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
    
    // Apply fade in animation
    if (this.content) {
      this.content.classList.remove('dropdown-hidden', 'dropdown-fade-out');
      this.content.classList.add('dropdown-fade-in', 'dropdown-visible');
    }
  }

  onMouseLeave() {
    // Add delay to allow for smooth transition when moving to submenu
    this.closeTimeout = setTimeout(() => {
      this.close();
    }, 100);
  }

  onToggle() {
    const isOpen = this.mainDetailsToggle.hasAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', isOpen.toString());

    if (isOpen) {
      // Modal is opening
      if (this.closeTimeout) { // Clear pending close from onMouseLeave if any
        clearTimeout(this.closeTimeout);
        this.closeTimeout = null;
      }
      
      if (this.content) {
        // Set classes for visibility and fade-in animation
        this.content.classList.remove('dropdown-hidden', 'dropdown-fade-out');
        this.content.classList.add('dropdown-fade-in', 'dropdown-visible');
      }
    } else {
      // Modal is closing
      // Call the main close method which handles animation and state.
      // It's guarded by `isAnimating` to prevent re-entry if already closing.
      this.close(); 
    }
  }

  close() {
    if (this.isAnimating) return;
    
    this.isAnimating = true;
    
    // Apply fade out animation
    if (this.content) {
      this.content.classList.remove('dropdown-visible', 'dropdown-fade-in');
      this.content.classList.add('dropdown-fade-out');
      
      // Wait for animation to complete before hiding
      setTimeout(() => {
        // Start fade out animation

        this.content.classList.add('dropdown-hidden');
        this.content.classList.remove('dropdown-fade-out');

        this.mainDetailsToggle.removeAttribute('open');
        this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
        
      }, 300); // Match CSS animation duration
    }
    

    // Reset animation state after animation completes
    setTimeout(() => {
      this.isAnimating = false;
    }, 300); // Match CSS animation duration
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    super.onToggle(); // Call parent's onToggle to handle dropdown visibility and animation

    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
